// client/src/routes/_auth/confirm-become-owner.$token.tsx — „Deveniți proprietar”, confirmed from
// the mail · D-3308.
//
// The path is the server's, not this file's: `RequestBecomeOwnerCommandHandler` composes
// `{origin}/confirm-become-owner/{token}` with nothing after the token, so the spelling is fixed.
//
// Under the pathless `_auth` layout, the frame for a page opened from a mail, as
// `/confirm-deletion/$token` is. Unlike that page this one cannot be used signed out: the link is
// spent with the refresh cookie (`POST /auth/become-owner` answers with a session of the new
// organization), so a visitor holding no session in this browser is sent to the login carrying
// the link as `redirect`, and comes back to it once signed in — `/confirm-become-owner` is one of
// the prefixes `safeRedirect` follows for exactly that. The token is bound to the account that
// asked, so signing in as anybody else ends on the page's „link no longer valid".

import { createFileRoute, redirect } from '@tanstack/react-router';

import { ConfirmBecomeOwner } from '@/features/auth/ConfirmBecomeOwner';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/confirm-become-owner/$token')({
  beforeLoad: async ({ location }) => {
    const session = await ensureSession();
    if (!session) throw redirect({ to: '/login', search: { redirect: location.href } });
  },
  component: ConfirmBecomeOwnerScreen,
});

function ConfirmBecomeOwnerScreen() {
  const { token } = Route.useParams();
  return <ConfirmBecomeOwner token={token} />;
}
